import docService from "@/CommonDP/service/doc-service";
import { difference } from "lodash-es";

export const separator = ',';
export const pathSeparator = '\\';

export const fileStore = {};

export async function getServerFiles(idList = []) {
  const ids = difference(idList, Object.keys(fileStore));
  if (ids.length) {
    const { data } = await docService.queryFilesByFileIds(ids);
    for (const file of data) {
      file.fileVersion ??= 1;
      file.absolutFolderPathId += pathSeparator + file.folderId;
      file.absolutFolderPathName += pathSeparator + file.folderName;
      fileStore[file.folderId] = file;
    }
  }
  return idList.map(id => fileStore[id]);
}
